import React from 'react'
import './Banner.css'
import Exclusive from './exclusive/Exclusive'


const Banner = () => {
  return (
    <section className='Banner'>
        <div className='banner_img_holder'>
            <img src={process.env.PUBLIC_URL + '/assets/images/insight/banner/banner.png'} className='banner_img'/>
        </div>

        <div className='exclusive_div'>
            <Exclusive/>
        </div>

    </section>
  )
}

export default Banner
